import { render, staticRenderFns } from "./RetailConnect.vue?vue&type=template&id=12fd46d8"
import script from "./RetailConnect.vue?vue&type=script&lang=js"
export * from "./RetailConnect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports